import {
  FETCH_NOTIFICATIONS_REQUEST,
  FETCH_NOTIFICATIONS_SUCCESS,
  FETCH_NOTIFICATIONS_FAILURE,
  FETCH_ALL_NOTIFICATIONS_REQUEST,
  FETCH_ALL_NOTIFICATIONS_SUCCESS,
  FETCH_ALL_NOTIFICATIONS_FAILURE,
  MARK_NOTIFICATION_AS_READ_REQUEST,
  MARK_NOTIFICATION_AS_READ_SUCCESS,
  MARK_NOTIFICATION_AS_READ_FAILURE,
  SEND_NOTIFICATION_REQUEST,
  SEND_NOTIFICATION_SUCCESS,
  SEND_NOTIFICATION_FAILURE,
  SEND_BROADCAST_NOTIFICATION_REQUEST,
  SEND_BROADCAST_NOTIFICATION_SUCCESS,
  SEND_BROADCAST_NOTIFICATION_FAILURE,
} from '../actions/types';

const initialState = {
  notifications: [],
  allNotifications: [],
  loading: false,
  error: null,
  message: '',
  page: 1,
  hasMore: true,
};

export default function notificationReducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_NOTIFICATIONS_REQUEST:
    case FETCH_ALL_NOTIFICATIONS_REQUEST:
    case MARK_NOTIFICATION_AS_READ_REQUEST:
    case SEND_NOTIFICATION_REQUEST:
      return { ...state, loading: true, error: null };

    case FETCH_NOTIFICATIONS_SUCCESS:
      return {
        ...state,
        loading: false,
        notifications: action.payload,
        page: action.payload.page,
        hasMore: action.payload.hasMore,
        message: 'Notifications loaded successfully',
      };

    case FETCH_ALL_NOTIFICATIONS_SUCCESS:
      return {
        ...state,
        loading: false,
        allNotifications: action.payload,
        message: 'All notifications loaded successfully',
      };

    case MARK_NOTIFICATION_AS_READ_SUCCESS:
      return {
        ...state,
        loading: false,
        notifications: state.notifications.map((notification) =>
          notification.id === action.payload
            ? { ...notification, read_status: 'Read' }
            : notification
        ),
        allNotifications: state.allNotifications.map((notification) =>
          notification.id === action.payload
            ? { ...notification, read_status: 'Read' }
            : notification
        ),
        message: 'Notification marked as read',
      };

    case SEND_NOTIFICATION_SUCCESS:
      return {
        ...state,
        loading: false,
        message: 'Notification sent successfully',
      };

    case FETCH_NOTIFICATIONS_FAILURE:
    case FETCH_ALL_NOTIFICATIONS_FAILURE:
    case MARK_NOTIFICATION_AS_READ_FAILURE:
    case SEND_NOTIFICATION_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case SEND_BROADCAST_NOTIFICATION_REQUEST:
      return { ...state, loading: true, error: null };

    case SEND_BROADCAST_NOTIFICATION_SUCCESS:
      return {
        ...state,
        loading: false,
        message: "Broadcast notification sent successfully",
      };

    case SEND_BROADCAST_NOTIFICATION_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
}
